import dateAndTimeConstants from 'utils/dateAndTimes/constants';

import joinTimeAndDate from 'utils/dateAndTimes/methods/joinTimeAndDate';
import getDateKeyFromTimeKey from 'utils/dateAndTimes/methods/getDateKeyFromTimeKey';
import { methods as addressesMethods } from 'utils/addresses';

import isDateToday from 'utils/dateAndTimes/methods/isDateToday';

const joinTimesWithDates = (times) => {
  let joined = {};
  const keys = dateAndTimeConstants.DATE_AND_TIME_KEYS;

  joined = keys.reduce(
    (acc, key) => ({
      ...acc,
      [key]: joinTimeAndDate(
        times[key] || '00:00',
        times[getDateKeyFromTimeKey(key)],
        times[addressesMethods.getTimezoneFromAddressFromTimeKey(key)]
      ),
    }),
    {}
  );

  joined = {
    ...joined,
    isToday: times.pickup_date_from
      ? isDateToday(times.pickup_date_from, times.pickup_timezone)
      : true,
  };

  return joined;
};

export default joinTimesWithDates;
